<template>
  <div v-show="existProcess" class="mr-4 relative rounded-full bg-slate-100 p-1">
    <!-- disparador en la navbar: reabre el toast si estaba cerrado -->
    <a class="text-black hover:text-grey" @click="reopen">
      <b-icon icon="tasks" pack="fas" size="is-small" class="float-left"></b-icon>
      <span
        v-if="activeCount > 0"
        class="px-1 py-0 text-xs text-white rounded-full bg-red absolute -bottom-1 -right-1">
        {{ activeCount }}
      </span>
    </a>

    <!-- ================= TOAST estilo Google Drive ================= -->
    <transition name="toast-pop">
      <div
        v-if="toastVisible"
        class="process-toast"
        :class="{ collapsed: collapsed, active: activeCount > 0 }"
        style="z-index: 1000">
        <!-- cabecera -->
        <div class="toast-head" @click="toggleCollapse">
          <div class="toast-title">
            {{ $t('processes') }}
            <small>{{ subtitle }}</small>
          </div>
          <b-tooltip :label="$t('clean')" position="is-top">
            <button type="button" class="head-btn" @click.stop="clearAllPending">
              <b-icon icon="broom" pack="fas" size="is-small"></b-icon>
            </button>
          </b-tooltip>
          <button type="button" class="head-btn" :aria-label="$t('collapse')" @click.stop="toggleCollapse">
            <b-icon icon="chevron-down" pack="fas" size="is-small" class="chevron"></b-icon>
          </button>
          <button type="button" class="head-btn" :aria-label="$t('close')" @click.stop="closeToast">
            <b-icon icon="times" pack="fas" size="is-small"></b-icon>
          </button>
        </div>

        <!-- cuerpo -->
        <div class="toast-body">
          <process-item
            v-for="queue in listQueue"
            :key="queue.id"
            :data="queue"
            @processlog-deleted="removeProcessItem"></process-item>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EventBus from '~/plugins/bus'
import axios from 'axios'
import { mapGetters } from 'vuex'

import ProcessItem from './ProcessItem.vue'

export default {
  name: 'process-queue',

  props: {
  },

  components: {
    ProcessItem
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    // existen procesos pendientes o en proceso
    existProcess() {
      return this.listQueue.filter(obj => obj.status < 2).length > 0
    },

    // procesos en cola / en curso (status 0 o 1)
    activeCount() {
      return this.listQueue.filter(obj => obj.status < 2).length
    },

    completedCount() {
      return this.listQueue.filter(obj => obj.status === 2).length
    },

    // el toast se muestra si hay procesos y el usuario no lo ha cerrado
    toastVisible() {
      return !this.userClosed && this.listQueue.length > 0
    },

    subtitle() {
      if (this.activeCount > 0) {
        return this.activeCount + ' ' + this.$t('in_progress')
      }
      return this.$t('all_completed')
    },
  },

  data: () => ({
    loading: false,

    collapsed: false,
    userClosed: false,

    listQueue: []
  }),

  created() {
    this.loadProcesslog()
    var self = this

    // al recibir un evento de proceso, refrescamos y mostramos el toast
    EventBus.$on('processQueueLog', function (e) {
      let found = self.listQueue.find(obj => obj.queue === e.data.queue)

      if (found) {
        found.status = e.data.status
        found.description_status = e.data.description_status
        found.progress = e.data.progress
      } else {
        self.listQueue.unshift(e.data)
      }

      // si llega un proceso en curso, reabrimos el toast (comportamiento tipo Drive)
      if (e.data.status < 2) {
        self.userClosed = false
      }
    })
  },

  beforeDestroy() {
    EventBus.$off('processQueueLog')
  },

  methods: {

    async loadProcesslog() {
      var self = this

      await axios.get('/api/v2/user/' + this.user.id + '/processlog')
        .then(function (response) {
          if (response.data && response.data.success) {
            self.listQueue = response.data.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    toggleCollapse() {
      this.collapsed = !this.collapsed
    },

    closeToast() {
      // Al cerrar quitamos del toast los concluidos (completado = 2) y con error (>= 3);
      // los que siguen en cola/en curso (status < 2) se mantienen vivos (badge + reabrir).
      // Solo se quitan de la lista local; no se borran del servidor (histórico intacto).
      this.listQueue = this.listQueue.filter(item => item.status < 2)
      this.userClosed = true
    },

    // reabre desde el icono de la navbar
    reopen() {
      this.userClosed = false
      this.collapsed = false
    },

    removeProcessItem(id) {
      this.listQueue = this.listQueue.filter(item => item.id !== id)
    },

    async clearAllPending() {
      const idsToDelete = this.listQueue
        .filter(item => item.status === 0 || item.status === 1)
        .map(item => item.id)
      if (!idsToDelete.length) return
      const response = await axios.post('/api/v2/processlog/batch-delete', { ids: idsToDelete })
      if (response.data && response.data.success) {
        this.listQueue = this.listQueue.filter(item => !(item.status === 0 || item.status === 1))
      } else {
        this.$buefy.toast.open({
          message: this.$t('error_deleting'),
          type: 'is-danger'
        })
      }
    },
  },

};
</script>

<style scoped>
.process-toast {
  position: fixed;
  /* desplazado a la izquierda para no solaparse con el widget de chat (abajo-dcha) */
  right: 180px;
  bottom: 0;
  width: 352px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  /* borde 1px (arriba + laterales) visible al estar expandido; azul si hay actividad */
  border: 1px solid #e2e7ee;
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 10px 30px -8px rgba(23, 38, 63, 0.28), 0 2px 8px -2px rgba(23, 38, 63, 0.12);
  overflow: hidden;
  transform-origin: bottom right;
}

.process-toast.active {
  border-color: #2f6fed;
}

/* al colapsar se oculta el borde */
.process-toast.collapsed {
  border-color: transparent;
}

@media (max-width: 640px) {
  .process-toast { right: 16px; }
}

/* cabecera */
.toast-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 10px 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e7ee;
  cursor: pointer;
  user-select: none;
}
.toast-title {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  color: #1c2430;
  line-height: 1.2;
}
.toast-title small {
  display: block;
  font-size: 11.5px;
  font-weight: 500;
  color: #5a6676;
  margin-top: 1px;
}
.head-btn {
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: #5a6676;
  border-radius: 7px;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.15s, color 0.15s;
}
.head-btn:hover {
  background: #eef1f5;
  color: #1c2430;
}
.chevron {
  transition: transform 0.28s ease;
}
.process-toast.collapsed .chevron {
  transform: rotate(180deg);
}

/* cuerpo */
.toast-body {
  max-height: 340px;
  overflow-y: auto;
  transition: max-height 0.3s ease, opacity 0.25s ease;
}
.process-toast.collapsed .toast-body {
  max-height: 0;
  opacity: 0;
}

/* animación de aparición */
.toast-pop-enter-active {
  animation: toast-pop-in 0.32s cubic-bezier(0.2, 0.8, 0.25, 1);
}
.toast-pop-leave-active {
  animation: toast-pop-in 0.2s reverse;
}
@keyframes toast-pop-in {
  from { opacity: 0; transform: translateY(14px) scale(0.98); }
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .toast-pop-enter-active,
  .toast-pop-leave-active { animation: none; }
  .chevron,
  .toast-body { transition: none; }
}
</style>
